import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from "@angular/router";
import { ResolveDataService } from "../services/resolve-data.service";


export const JobDocumentTypesResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
{
  const resolveDataService = inject(ResolveDataService);

  return resolveDataService.resolveJobDocumentTypes();
}; 
